/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch
 */
export interface SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch
   */
  name?: string | null;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch
   */
  spitchEndpoint: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch
   */
  spitchUserId: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch
   */
  spitchChannelId: string;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch interface.
 */
export function instanceOfSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch(
  value: object,
): value is SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('spitchEndpoint' in value) || value['spitchEndpoint'] === undefined) return false;
  if (!('spitchUserId' in value) || value['spitchUserId'] === undefined) return false;
  if (!('spitchChannelId' in value) || value['spitchChannelId'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchFromJSON(
  json: any,
): SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch {
  return SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    spitchEndpoint: json['spitch_endpoint'],
    spitchUserId: json['spitch_user_id'],
    spitchChannelId: json['spitch_channel_id'],
  };
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchToJSON(
  value?: Omit<SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    spitch_endpoint: value['spitchEndpoint'],
    spitch_user_id: value['spitchUserId'],
    spitch_channel_id: value['spitchChannelId'],
  };
}
